import { colors } from '@sweep-io/sweep-design';

export const resizeControlStyles = {
  handle: {
    width: 14,
    height: 14,
    borderWidth: 2,
    borderRadius: 4,
    borderColor: colors.blue[500],
  },
  line: {
    borderColor: colors.blue[500],
    borderWidth: 1,
  },
};
